import MJSONDesigner from '@admin/components/mjson_designer'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

class Design extends React.Component {

  static propTypes = {
    provider: PropTypes.object
  }

  render() {
    return <MJSONDesigner { ...this._getMJSONDesigner() } />
  }

  _getMJSONDesigner() {
    const { provider } = this.props
    return {
      editable: true,
      endpoint: `/maha_providers/${provider.id}`,
      root_route: `/platform/providers/${provider.id}/design`,
      type: 'email',
      versionable: true
    }
  }

}

const mapPropsToPanel = (props, context) => ({
  title: 't(Design)',
  component: <Design provider={ props.provider } />
})

export default Panel(null, mapPropsToPanel)
